import { gql } from "@apollo/client"
import { TRIP_ORDERS_FRAG } from "./dispatch.fragments.gql"

export const ADD_UPDATE_DISPATCH = gql`
  mutation CreateUpdateDispath(
    $aggregatorId: ID!
    $bookings: [DispatchBookingItem]
    $date: Date!
    $destinationDepotId: ID!
    $estimatedStartTime: DateTime!
    $id: ID
    $labourCount: Int
    $organisationUserId: ID!
    $sourceDepotId: ID!
    $transportDetail: VehicleTransportInput
    $vehicleId: ID!
    $loadingPattern: String
    $estimatedDespatchTime: DateTime
  ) {
    addUpdateDispatch(
      id: $id
      aggregatorId: $aggregatorId
      date: $date
      destinationDepotId: $destinationDepotId
      estimatedStartTime: $estimatedStartTime
      organisationUserId: $organisationUserId
      sourceDepotId: $sourceDepotId
      vehicleId: $vehicleId
      labourCount: $labourCount
      transportDetail: $transportDetail
      bookings: $bookings
      loadingPattern: $loadingPattern
      estimatedDespatchTime: $estimatedDespatchTime
    ) {
      trip {
        ...TripOrdersFrag
      }
    }
  }
  ${TRIP_ORDERS_FRAG}
`
